import moment from 'moment';
import { authService } from '../../core/auth';

let delay;
let refreshTokenInterval;
const handleUpdateToken = (tokenQuery, refreshToken) => {
    const expirationTime = localStorage.getItem('uuid');
    const tokenExpireTime = moment(expirationTime, "x");
    const nowTime = moment();
    delay = tokenExpireTime.diff(nowTime, 'milliseconds');
    refreshTokenInterval = setInterval(() => {
        callUpdateToken(tokenQuery, refreshToken);
    }, delay);
    return () => clearInterval(refreshTokenInterval);
}

const callUpdateToken = (tokenQuery, refreshToken) => {
    tokenQuery.callLazyQuery({ variables: { refreshToken } });
}

const updateTokenLocalStorage = (result, tokenQuery, refreshToken) => {
    authService.addToken(result.refreshToken.token)
    clearRefreshIntervalDelay();
    handleUpdateToken(tokenQuery, refreshToken);
}

const clearRefreshIntervalDelay = () => {
    clearInterval(refreshTokenInterval)
}
export const updateUpdateTokenService = {
    handleUpdateToken,
    updateTokenLocalStorage,
    clearRefreshIntervalDelay
}